import { createHook } from '@atomify/hooks';

const BUTTON_LOADING_CLASS = 'is-loading';

export const useButtonLoadingState = (
    buttonHook: string,
    buttonLoadingClass = BUTTON_LOADING_CLASS,
) =>
    createHook({
        onDidLoad: element => (loading: boolean) => {
            const buttonElement = element.querySelector<HTMLButtonElement>(buttonHook);
            if (!buttonElement) return;

            if (loading) {
                buttonElement.classList.add(buttonLoadingClass);
            } else {
                buttonElement.classList.remove(buttonLoadingClass);
            }
        },
    });
